// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__wifUT {
  padding: unset; }
  .styles_container__wifUT > div {
    padding: 1rem 3rem; }
    .styles_container__wifUT > div div p {
      font-size: 1.125rem;
      margin-bottom: 0.5rem; }

.styles_fieldsContainer__WaoEC > div {
  margin-top: 1rem; }
`, "",{"version":3,"sources":["webpack://./src/modules/Core/components/form/ObjectField/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,cAAc,EAAA;EADhB;IAGI,kBAAkB,EAAA;IAHtB;MAKM,mBAAmB;MACnB,qBAAqB,EAAA;;AAK3B;EACE,gBAAgB,EAAA","sourcesContent":[".container {\n  padding: unset;\n  & > div {\n    padding: 1rem 3rem;\n    & div p {\n      font-size: 1.125rem;\n      margin-bottom: 0.5rem;\n    }\n  }\n}\n\n.fieldsContainer > div{\n  margin-top: 1rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__wifUT`,
	"fieldsContainer": `styles_fieldsContainer__WaoEC`
};
export default ___CSS_LOADER_EXPORT___;
